import { useState } from 'react'

import { createStyles } from 'antd-style'

import { pretty } from '@eastcoal/common/utils/decimal'

import { useKindQuantityRequest } from './useKindQuantityRequest'

const useStyles = createStyles(({ token }) => ({
  container: {
    paddingInline: token.padding
  },
  title: {
    display: 'inline-block',
    paddingInlineEnd: token.paddingXL * 2,
    paddingBlockStart: token.paddingSM,
    fontSize: token.fontSizeHeading5,
    cursor: 'pointer',
    [`&.is-selected`]: {
      color: token.colorPrimaryTextActive
    },
    [`&:hover`]: {
      color: token.colorPrimaryTextHover
    }
  },
  centent: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3,1fr)',
    marginBlockStart: token.marginMD
  },
  stastics: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: token.paddingSM
  },
  label: {},
  value: {
    fontSize: token.fontSizeXL,
    fontWeight: 'bold',
    color: token.blue8
  }
}))

const KindList = [
  {
    label: '煤炭',
    value: 1
  },
  {
    label: '再生资源',
    value: 2
  },
  {
    label: '化工',
    value: 3
  },
  {
    label: '石料',
    value: 4
  }
] as const

export const DataDashboard = () => {
  const [selectedKey, setSelectedKey] = useState<number>(KindList[0].value)
  const items = useKindQuantityRequest({ type: selectedKey })

  const { cx, styles } = useStyles()

  return (
    <div className={styles.container}>
      {KindList.map(({ label, value }) => (
        <span
          key={value}
          role='button'
          tabIndex={0}
          className={cx(styles.title, {
            ['is-selected']: selectedKey === value
          })}
          onClick={() => setSelectedKey(value)}
        >
          {label}
        </span>
      ))}
      <div className={styles.centent}>
        {items.map(({ label, value, unit }) => (
          <div key={label} className={styles.stastics}>
            <span className={styles.value}>{pretty(value)}</span>
            <span className={styles.label}>
              {label}
              {unit ? `(${unit})` : ''}
            </span>
          </div>
        ))}
      </div>
    </div>
  )
}
